/** @format */

import React from "react";
import UsersTableContainer from "./UsersTable.container";
import { IUsers } from "../AccountInfoPage.types";

interface IUsersTableProps {
	users: IUsers[];
	fetchAndSetUsers: () => void;
}

const UsersTable: React.FC<IUsersTableProps> = ({
	users,
	fetchAndSetUsers,
}) => <UsersTableContainer users={users} fetchAndSetUsers={fetchAndSetUsers} />;

export default UsersTable;
